<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="90px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
    <!--      <el-form-item label="客户：">
            <el-select size="mini" v-model="form.propertyUnitId" filterable placeholder="请选择所属单位" clearable
              reserve-keyword :remote="true" @change="handleSearchListData" :remote-method="searchUnitList"
              @visible-change="searchUnitList('')">
              <el-option v-for="item in unitList" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="客户：" prop="propertyUnit">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.propertyUnitName"
              placeholder="请输入客户" clearable></el-input>
            </el-select>
          </el-form-item>
          <el-form-item label="应收类型：" prop="type">
            <el-select size="mini" v-model="form.type" filterable placeholder="请选择支出项" clearable
              @change="handleSearchListData">
              <el-option v-for="item in receiveTypeList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应收编号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.orderNo" placeholder="请输入工单编号"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="单据时间：">
            <el-date-picker v-model="form.createTimeBetween" size="mini" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd" unlink-panels
              clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="维修员:" prop="repairUserId">
            <el-select size="mini" v-model="form.repairUserId" filterable placeholder="请选择维修员" clearable
              @change="handleSearchListData">
              <el-option v-for="item in userList" :key="item.userId" :label="item.nickname"
                :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table  :row-class-name="tableRowClassName" :data="props.row.receiveList" height="100%" border style="width: 100%">
                <el-table-column show-overflow-tooltip prop="" label="" width="50"></el-table-column>
                <el-table-column show-overflow-tooltip prop="typeName" label="应收类型" width="80"></el-table-column>
                <el-table-column show-overflow-tooltip prop="inMoney" label="应收总金额" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveMoney" label="已收金额" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="notReceiveMoney" label="未收金额"
                  width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="invoiceMoney" label="开票金额" width="100">

                  <template slot-scope="scope">
                  <span v-if="scope.row.invoiceMoney != null" style="color: red; font-weight: 600;">{{ scope.row.invoiceMoney}}</span>
                </template>

                </el-table-column>
                <el-table-column show-overflow-tooltip prop="reminderAmount" label="催缴次数" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="overStatusName" label="应收状态" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="overDayAmount" label="逾期天数" width="80">
                  <!-- <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="handleShow(scope.row)">{{scope.row.overDayAmount}}</el-button>
                  </template> -->
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="sourceCode" label="关联单号" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="liftInfo" label="相关电梯" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="repairUserName" label="维保人员" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="passStatusName" label="是否收款" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="passDate" label="收款时间" width="200"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="100"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receiveNo" label="应收单据号" width="200"></el-table-column>
                <el-table-column show-overflow-tooltip prop="billDate" label="单据日期" width="200"></el-table-column>
                <el-table-column label=" " prop=" "></el-table-column>
                <el-table-column label="操作" width="98px" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="handleReminderList(scope.row)">催款</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="propertyUnitName" label="客户名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="grade" label="客户等级" width="80"></el-table-column>
          <el-table-column show-overflow-tooltip prop="inMoney" label="应收总金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="receiveMoney" label="已收金额" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="notReceiveMoney" label="未收金额" width="100"></el-table-column>

          <el-table-column show-overflow-tooltip prop="projectNameStr" label="项目" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="principal" label="联系人" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="principalPhone" label="电话" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="" label="" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.receiveList.length}}笔</span>
            </template>
          </el-table-column>

          <el-table-column show-overflow-tooltip prop="maxOverDayAmount" label="最大逾期天数" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="lastMarkDate" label="最新催款日期" width="100"></el-table-column>

          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <reminder-list v-if="reminderListVisible" :detail="causeDetail" @cancel="reminderListVisible = false"
      @confirm="handleReminderListVisibleConfirm">
    </reminder-list>
    <check-order v-if="checkOrder" :editData="causeDetail" @cancel="checkOrder = false"></check-order>
  </div>
</template>

<script>
  import {
    getPropertyUnitSimpleList,
  } from "@/api/AnnualInspection";
  import {
    getReminderPageList,
    getReceiveTypeList,
    userSimpleList,
  } from "@/api/Receive";
  import ReminderList from './components/ReminderList'
  import CheckOrder from '../RecoveryWorkOrder/components/CheckOrder'
  import {
    mapState
  } from "vuex";
  export default {
    name: "ReceiveReminderManagement",
    components: {
      ReminderList,
      CheckOrder
    },
    data() {
      return {
        form: {
          departmentIdList: [],
          propertyUnitId: "",
          projectId: "",
          useCertificateNumber: "",
          cityCode: "",
          districtCode: "",
          provinceCode: "",
          liftLocation: "",
          orderNo: "",
          startCreateTime: "",
          endCreateTime: "",
          createTimeBetween: null,
          signatureStatus: "",
          overdueStatus: "",
          locationStatus: "",
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        causeDetail: {},
        unitList: [],
        reminderListVisible: false,
        checkOrder: false,
        receiveTypeList: [],
        userList: []
      };
    },
    computed: {
      hasRole: function() {
        return this.$store.getters["common/promise/getRole"](this.$route.path);
      },
      ...mapState("common/dictionary", ["WXDZTDicts"]),
    },
    created() {
      this.getListData();
      this.handleSpendingList();
      this.handleUserSimpleList();
    },
    methods: {
      tableRowClassName({ row, rowIndex }) {
        if (row.overDayAmount >= 30) {
          return 'warning-row'
        } else if (row.overDayAmount >= 10) {
          return 'oldlace';
        } else {
          return 'success-row';
        }
      },
      handleShow(row) {
        if (row.type == 30) {
          if(!row.sourceId) {
            this.$message.warning('当前数据不支持')
          }
          this.causeDetail = {
            orderId: row.sourceId
          }
          this.checkOrder = true
        } else if (row.type == 20) {
          this.$router.push({
            name: "ContractDetail",
            query: {
              contractNumber: row.sourceCode,
              canEdit: false,
            },
          });
        } else {
          this.$message.warning('暂不支持当前类型')
        }
      },
      async handleUserSimpleList() {
        const res = await userSimpleList({});
        if (res.code === 200) {
          this.userList = res.data
        }
      },
      handleReminderList(row) {
        this.causeDetail = row
        this.reminderListVisible = true
      },
      handleReminderListVisibleConfirm() {
        this.reminderListVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      async handleSpendingList() {
        const res = await getReceiveTypeList();
        if (res.code === 200) {
          this.receiveTypeList = res.data
        }
      },
      async getListData() {
        this.tableLoading = true;
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        for (let key in this.form) {
          if (this.form[key]) params[key] = this.form[key];
        }
        if (this.form.createTimeBetween) {
          delete params.createTimeBetween;
          params.endCreateTime = this.form.createTimeBetween[1];
          params.startCreateTime = this.form.createTimeBetween[0];
        }
        const res = await getReminderPageList(params);
        if (res.code === 200) {
          this.total = res.data.total;
          this.list = res.data.list;
        }
        this.tableLoading = false;
      },
      handleSearch() {
        this.pageIndex = 1;
        this.getListData();
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = [];
          } else {
            this.form[key] = "";
          }
        }
        this.pageIndex = 1;
        this.getListData();
      },
      handleSearchListData() {
        this.pageIndex = 1;
        this.getListData();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleDeleteUnit(row) {
        const idList = [row.orderId];
        this.deleteOrder(idList);
      },

      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning("请选择要删除的行");
          return;
        }
        const idList = this.multipleSelection.map((item) => item.orderId);
        this.deleteOrder(idList);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getListData();
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getListData();
      },
      async searchUnitList(keyword) {
        const res = await getPropertyUnitSimpleList({
          keyword: keyword,
          size: 1000,
        });
        if (res.code === 200) {
          this.unitList = res.data;
        }
      }
    },
  };
</script>

<style>

.el-table .warning-row {
  background: #f19090;
}

.el-table  .oldlace {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/ReceiveReminderManagement/ReceiveReminderManagement.vue